export var FileStatus;

(function (FileStatus) {
  FileStatus["INIT"] = "INIT";
  FileStatus["LOADING"] = "LOADING";
  FileStatus["DONE"] = "DONE";
  FileStatus["FAIL"] = "FAIL";
  FileStatus["ABORT"] = "ABORT";
})(FileStatus || (FileStatus = {}));

export var FileType;

(function (FileType) {
  FileType["IMAGE"] = "image";
  FileType["VIDEO"] = "video";
  FileType["AUDIO"] = "audio";
  FileType["FILE"] = "file";
})(FileType || (FileType = {}));